import { clientClient } from 'servicesCommon/client';
import { AxiosTypedPromise } from 'servicesCommon/apiTypes';

import {
	ValidateAddressRequest,
	ValidateAddressResponse,
	RetrieveGoogleAddressRequest,
	RetrieveGoogleAddressResponse,
	RetrieveAddressSuggestionsRequest,
	AddressSuggestionsResponse,
} from './AddressesTypes';

const formatUrl = (url: string) => `/addresses/${url}`;
export const addressesApi = {
	validateGoogleAddress(
		params?: ValidateAddressRequest
	): AxiosTypedPromise<ValidateAddressResponse> {
		return clientClient.get(formatUrl('validate-address'), {
			params,
		});
	},
	getAddressDetails(
		params?: RetrieveGoogleAddressRequest
	): AxiosTypedPromise<RetrieveGoogleAddressResponse> {
		return clientClient.get(formatUrl('get-address-details'), {
			params,
		});
	},

	getAddressSuggestions(
		params?: RetrieveAddressSuggestionsRequest
	): AxiosTypedPromise<AddressSuggestionsResponse> {
		return clientClient.get(formatUrl('get-address-suggestions'), {
			params,
		});
	},
};
